import React, { useEffect } from 'react'
import UserAnswerWithQuestionDto from '../../../Interfaces/UserAnswerWithQuestionDto'
import ImageSrc from '../../../Helper/ImageSrc'

interface props{
    dataAnswered: UserAnswerWithQuestionDto[] | undefined
}
function ScoreViewResults({dataAnswered}:props) {
//console.log(dataAnswered);
  return (
<div>
        {
            dataAnswered?.map((rowData, rowIndex) => {
              return(
                  <div key={rowIndex} className="card p-3 mt-3">
                <p>
                    <strong>Question {rowIndex + 1}:</strong><br />
                    {   rowData.questions.questionText
                        ?.split('\n')
                        .map((line, index) => (
                            <span key={index}>
                                {line}
                                <br />
                            </span>
                    ))} { 
                    rowData.questions.questionImageUrl && 
                    ImageSrc(rowData?.questions?.questionImageUrl)
                    // <ImageHelper url={rowData?.questions?.questionImageUrl}/> 
                   }
                </p>
                <div className='mb-2'>
                  {rowData.isCorrect ? <i className="bi bi-check-circle"></i> : <i className="bi bi-file-excel"></i>}
                  <span> <strong>{rowData.correctLetterAnswer === "A" ? "1." :
                           rowData.correctLetterAnswer === "B" ? "2." :
                           rowData.correctLetterAnswer === "C" ? "3." :
                           rowData.correctLetterAnswer === "D" ? "4." : "5"
                        }
                        {" "}
                        {
                          rowData?.questions?.answerKeyImageUrl 
                          ? ImageSrc(rowData?.questions?.answerKeyImageUrl)
                          // ? <ImageHelper url={rowData?.questions?.answerKeyImageUrl}/>  
                          : rowData.questions.answerKey
                        }
                      
                        </strong>
                          {" Is The Answer"}
                        </span>
                   
                </div>
<div style={{
  display: "flex",
  flexWrap: "wrap",
  gap: "1rem"
}}>
           
<div  
    className={
  rowData?.questions.choice?.a === rowData.userAnswer
    ? rowData.isCorrect
      ? "text-primary"   // ✅ correct → blue
      : "text-danger"    // ❌ wrong → red
    : "text-black"       // neutral → black
}>
  <span>1</span>
  <input 
    className="ms-1"
    type="radio"
    name={`${rowData?.questions.id}`}
    value={rowData?.questions.choice?.a}
    
    checked={
      rowData.letterAnswer == "A"
    } readOnly
  />{" "}
   {
      rowData?.questions?.choice?.choiceAImageUrl
      ? ImageSrc(rowData?.questions?.choice?.choiceAImageUrl)
      // ? <ImageHelper url={rowData?.questions?.choice?.choiceAImageUrl}/> 
      : rowData.questions.choice?.a
    }
</div>

<div  
    className={
  rowData?.questions.choice?.b === rowData.userAnswer
    ? rowData.isCorrect
      ? "text-primary"   // ✅ correct → blue
      : "text-danger"    // ❌ wrong → red
    : "text-black"       // neutral → black
}>
  <span>2</span>
  <input
    className="ms-1"
    type="radio"
    name={`${rowData?.questions.id}`}
    value={rowData?.questions.choice?.b}
    checked={rowData.letterAnswer == "B" }readOnly
  />{" "}
  { rowData?.questions?.choice?.choiceBImageUrl 
      ? ImageSrc(rowData?.questions?.choice?.choiceBImageUrl)
      // ? <ImageHelper url={rowData?.questions?.choice?.choiceAImageUrl}/> 
      : rowData.questions.choice?.b
  }
</div>
<div  
    className={
  rowData?.questions.choice?.c === rowData.userAnswer
    ? rowData.isCorrect
      ? "text-primary"   // ✅ correct → blue
      : "text-danger"    // ❌ wrong → red
    : "text-black"       // neutral → black
}>
  <span>3</span>
  <input
    className="ms-1"
    type="radio"
    name={`${rowData?.questions.id}`}
    value={rowData?.questions.choice?.c}
    checked={rowData.letterAnswer == "C"} readOnly
  />{" "}
  {
     rowData?.questions?.choice?.choiceCImageUrl
      ? ImageSrc(rowData?.questions?.choice?.choiceCImageUrl)
      // ? <ImageHelper url={rowData?.questions?.choice?.choiceAImageUrl}/> 
      : rowData.questions.choice?.c
  }
</div>

<div 
className={
    rowData?.questions.choice?.d === rowData.userAnswer ? rowData.isCorrect
      ? "text-primary" // if condition is true
      : "text-danger"  // if condition is false
      : "text-black"
  }>
  <span>4.</span>
  <input
    className="ms-1"
    type="radio"
    name={`${rowData?.questions.id}`}
    value={rowData?.questions.choice?.d}
    checked={rowData.letterAnswer == "D"} readOnly
  />{" "}
  {
     rowData?.questions?.choice?.choiceDImageUrl
      ? ImageSrc(rowData?.questions?.choice?.choiceDImageUrl)
      // ? <ImageHelper url={rowData?.questions?.choice?.choiceAImageUrl}/> 
      : rowData.questions.choice?.d
  }
</div>
<div style={{ display: !rowData?.questions.choice?.e ? "none" : "block" }}
className={
    rowData?.questions.choice?.e === rowData.userAnswer ? rowData.isCorrect
      ? "text-primary" // if condition is true
      : "text-danger"  // if condition is false
      : "text-black"
  }>
  <span>5.</span>
  <input
    className="ms-1"
    type="radio"
    name={`${rowData?.questions.id}`}
    value={rowData?.questions.choice?.e}
    checked={rowData.letterAnswer == "E"} readOnly
  />{" "}
  {
     rowData?.questions?.choice?.choiceEImageUrl
      ? ImageSrc(rowData?.questions?.choice?.choiceEImageUrl)
      // ? <ImageHelper url={rowData?.questions?.choice?.choiceAImageUrl}/> 
      : rowData.questions.choice?.e
  }
</div>



</div>
</div>

              )
            })
        }
</div>
  )
}

export default ScoreViewResults